import React, { useEffect, useState } from 'react';
import { Parte, PartesAdapter } from '../../../../../infraestructure/persistence/rest/PartesAdapter';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import FormularioAdjuntar from '../Adjuntos/adjuntar';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { AdjuntosAdapter } from '../../../../../infraestructure/persistence/rest/AdjuntosAdapter';

export const FormularioAdjuntarContainer = (props: any) => {
  let { handle, selected, onClose} = props;
  const {resultError, exceptionError, launchNotification} = useNotifications();
  let [isUpload, setIsUpload] = useState(false);
  let [data, setData] = useState([]);
	let [dataTamañoAdjuntos, setDataTamañoAdjuntos]=useState([]);

  const api = new PartesAdapter();
  const apiAdjuntos = new AdjuntosAdapter();
	let result: any;

  useEffect(()=>{getTamañosAdjuntosPartes();},[selected])
  useEffect(()=>{setIsUpload(false);},[props])
  useEffect(()=>{
    if(isUpload){onAdjuntar(data)}
  },[isUpload])

  const adjuntarFicheros = async (data: any) => {
		try {
      result = await api.AdjuntarFicheros(data);
      if(result.data && result.data!=="")
			{
        launchNotification({type:"success",title:"Adjuntar",message:"Se han adjuntado archivos."})
        return result.data;
      }else{resultError(); return false}
		} catch (e) {
			let exception = ServerErrorMessage(e);
      setIsUpload(false)
      exceptionError(exception)
		}
  };

  const getTamañosAdjuntosPartes = async()=>{
    const IdsPartes:number[] = selected.map((s:Parte)=>s.idParte);
    try {
      result = await apiAdjuntos.GetTamañosAdjuntos(IdsPartes);
      if(result.data && result.data!=="")
			{
        setDataTamañoAdjuntos(result.data);
      }else{resultError(); return false}
		} catch (e) {
			let exception = ServerErrorMessage(e);
      setIsUpload(false)
      exceptionError(exception)
		}
  }
  
  const onSave = (data: any) =>{
    setData(data)
    setIsUpload(true)
  }

	const onAdjuntar = async (data: any) => {
    let result = await adjuntarFicheros(data);

    if (result && handle) {
      handle();
    }
  };
	
	return <FormularioAdjuntar onSave={onSave} selected={selected} isUpload={isUpload} onClose={onClose} dataTamañoAdjuntos={dataTamañoAdjuntos}/>;
}

export default FormularioAdjuntarContainer;